<template>
    <div class="tsa-basicInfo">
        <div class="title">
            <p>作品基本信息</p>
        </div>
        <div class="info">
            <template v-if="result.type === 0">
                <div class="item">
                    <div class="name">
                        <p>作品类型</p>
                    </div>
                    <p class="value">{{ result.category | mapFilter(categorysList) }}</p>
                </div>
            </template>
            <div class="item">
                <div class="name">
                    <p>作品名称</p>
                </div>
                <p class="value">{{ result.name }}</p>
            </div>
            <div class="item desc">
                <div class="name">
                    <p>作品简介</p>
                </div>
                <p class="value">{{ result.description }}</p>
            </div>
            <template v-if="result.type === 1">
                <div class="item">
                    <div class="name">
                        <p>总集数</p>
                    </div>
                    <p class="value">{{ result.totalEpisodes ? result.totalEpisodes + '集' : '' }}</p>
                </div>
                <div class="item">
                    <div class="name">
                        <p>类型</p>
                    </div>
                    <p class="value">{{ result.genre | typeTextFilter(result.categoryNames) }}</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { categorysList } from '@/config/copyright/categorysList'
export default {
    props: {
        result: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
            categorysList
        }
    },
}
</script>

<style lang="scss" scoped>
    @import './css/mobile.scss';
</style>